<template lang='pug'>
    v-tabs#customer-tabs( 
        color='grey lighten-4'  
        grow 
        :height='72'
        show-arrows
        slider-color='primary'
    )
        v-tab general
        v-tab-item
            customer-detail-general
        v-tab comercial
        v-tab-item
            customer-commercial-info
        v-tab reciente
        v-tab-item
            customer-recent-invoice
        v-tab con deuda
        v-tab-item
            customer-receivable
        v-tab morosos
        v-tab-item
            customer-defaulter-invoice-list
        v-tab notas de crédito
        v-tab-item
            customer-credit-note
        v-tab notas de débito
        v-tab-item
            customer-debit-note
        v-tab Facturas históricas
        v-tab-item
            customer-historic-invoice
        v-tab cuenta corriente
        v-tab-item
            customer-all-historic-document
        //- v-tab cuenta corriente
        //- v-tab-item
        //-     customer-current-account
</template>

<script>
import { mapActions } from 'vuex'
import DetailGeneral from './detail-general'
import {
    CustomerDetail,
    CustomerReceivableInvoice,
    CustomerRecentInvoice,
    CustomerDefaulterInvoiceList,
    CustomerHistoricInvoice,
    CustomerCurrentAccount,
    CommercialInfo,
    CustomerCreditNote,
    CustomerDebitNote,
    CustomerAllHistoricDocument,
} from './forms/'

import SlCustomerDetailView from '@/views/Sale/SlCustomer/SlCustomerDetail'
import SlCustomerDetailAccountView from '@/views/Sale/SlCustomer/SlCustomerDetailAccount'
import SlCustomerDetailCommercialView from '@/views/Sale/SlCustomer/SlCustomerDetailCommercial'
import SlCustomerDetailCreditNoteView from '@/views/Sale/SlCustomer/SlCustomerDetailCreditNote'
import SlCustomerDetailDebitNoteView from '@/views/Sale/SlCustomer/SlCustomerDetailDebitNote'
import SlCustomerDetailDefaulterView from '@/views/Sale/SlCustomer/SlCustomerDetailDefaulter'
import SlCustomerDetailHistoricView from '@/views/Sale/SlCustomer/SlCustomerDetailHistoric'
import SlCustomerDetailReceivableView from '@/views/Sale/SlCustomer/SlCustomerDetailReceivable'
import SlCustomerDetailRecentView from '@/views/Sale/SlCustomer/SlCustomerDetailRecent'

// Descuento, Vendedor, Plazo de Pago

export default {
    components: {
        'customer-detail-general'           : SlCustomerDetailView,
        'customer-commercial-info'          : SlCustomerDetailCommercialView,
        'customer-recent-invoice'           : SlCustomerDetailRecentView,
        'customer-receivable'               : SlCustomerDetailReceivableView,
        'customer-defaulter-invoice-list'   : SlCustomerDetailDefaulterView,
        'customer-historic-invoice'         : SlCustomerDetailHistoricView,
        'customer-current-account'          : SlCustomerDetailAccountView,
        'customer-credit-note'              : SlCustomerDetailCreditNoteView,
        'customer-debit-note'               : SlCustomerDetailDebitNoteView,
        'customer-all-historic-document'    : SlCustomerDetailAccountView,
    },
    computed: {

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        title() {
            return `Cliente #${this.$route.params.id}`
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    beforeMount() {
        this.setTitleTopBar(this.title)
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_FINANCE_CUSTOMER')) ctx.$router.push('/')
        })
    },
}
</script>

<style>
    #customer-tabs .v-tabs__bar.theme--light.grey.lighten-4 .v-tabs__wrapper {
        border-bottom: 1px solid #1a237e;
    }

    #customer-tabs .v-tabs__slider {
        height: 4px;
    }
</style>
